import { toDe } from '../sku-operations';

export const dataFormatter = (number: number) => {
  return toDe(number);
};
